import React from 'react';

import sanitizeHtml from 'sanitize-html';
import { getProfilePageSchema } from '../../../../helpers/schema';

interface IProps {
  fullName: string;
  nickname: string;
  avatarUrl: string;
}

export const AnglerSchema = ({ fullName, nickname, avatarUrl }: IProps) => {
  const anglerSchema = getProfilePageSchema({ fullName, nickname, avatarUrl });
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(anglerSchema) }}
    />
  );
};
